import React from 'react';
import { PropTypes } from 'prop-types';

import styles from './progressCircle/progressCircle.module.scss';

export const ProgressCircle = (props) => {
  const {
    className = '',
    size = 64,
    borderWidth = 4,
  } = props;

  const style = { width: `${size / 16}rem`, height: `${size / 16}rem` };
  const borderStyle = { ...style, borderWidth: `${borderWidth / 16}rem` };

  return (
    <div className={`${styles.container} ${className}`} style={style}>
      <div className={styles.track} style={borderStyle} />
      <div className={styles.fills}>
        <div className={`${styles.mask} ${styles.mask1}`}>
          <div className={styles.subMask1}>
            <div className={styles.fill} style={borderStyle} />
          </div>
        </div>
        <div className={`${styles.mask} ${styles.mask2}`}>
          <div className={styles.subMask2}>
            <div className={styles.fill} style={borderStyle} />
          </div>
        </div>
      </div>
    </div>
  );
};

ProgressCircle.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
  borderWidth: PropTypes.number,
};
